import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import _ from 'lodash';
import { RootState } from '../../../../../@types/RootState';

export type RulesPageDataKeyState = Record<'rule', string>;

export type RulesPageCustomRuleSortOptions = 'name' | 'productId';

const initialState: RulesPageDataKeyState = {
  rule: 'name',
};

const slice = createSlice({
  name: 'ipa.strategy.rules.table.datakeys',
  initialState,
  reducers: {
    RESET_RULES_TABLE_DATAKEYS: () => initialState,
    UPDATE_RULES_TABLE_DATAKEYS: (state, action: PayloadAction<Partial<RulesPageDataKeyState>>) => {
      return _.merge({}, state, action.payload);
    },
  },
});

export const selectorRulesPageTableDatakeys = (state: RootState) => {
  return state.ipa.strategy.rules.table.datakeys;
};

export const { UPDATE_RULES_TABLE_DATAKEYS, RESET_RULES_TABLE_DATAKEYS } = slice.actions;

export default slice.reducer;
